var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('SideBar',{on:{"page-name":_vm.setPage},model:{value:(_vm.selected_page),callback:function ($$v) {_vm.selected_page=$$v},expression:"selected_page"}}),_c('v-main',[_c('router-view',{staticClass:"absolute"}),_c('BHLensing'),_c('SkyHint'),_c('NightMountains'),_c('SocialSpeedDial'),_c('CopyRightFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }